import { normalizeProductNameKey } from "./productDocumentDto";

/**
 * Product rows in `projectstore-metadata`.
 *
 * Canonical products live at:
 *   pk = "{accountId}:product"
 *   sk = "!product:{productNameKey}"
 *
 * Workflow validation reads these rows directly; product-document link rows
 * are only the document lookup index.
 */
export interface ProductDto {
  readonly name?: string;
  readonly Name?: string;
  readonly nameKey?: string;
  readonly NameKey?: string;
  readonly archived?: boolean;
  readonly Archived?: boolean;
  readonly isArchived?: boolean;
  readonly IsArchived?: boolean;
  readonly entityType?: string;
  readonly EntityType?: string;
  readonly [extra: string]: unknown;
}

export function productPk(accountId: string): string {
  return `${accountId}:product`;
}

export function productSk(productName: string): string {
  return `!product:${normalizeProductNameKey(productName)}`;
}

export function productName(row: ProductDto): string {
  return firstString(row, ["name", "Name", "nameKey", "NameKey"]) ?? "";
}

export function isProductArchived(row: ProductDto): boolean {
  return firstBoolean(row, ["archived", "Archived", "isArchived", "IsArchived"]) ?? false;
}

function firstString(row: Record<string, unknown>, keys: ReadonlyArray<string>): string | null {
  for (const key of keys) {
    const value = row[key];
    if (typeof value !== "string") continue;
    const trimmed = value.trim();
    if (trimmed) return trimmed;
  }
  return null;
}

function firstBoolean(row: Record<string, unknown>, keys: ReadonlyArray<string>): boolean | null {
  for (const key of keys) {
    const value = row[key];
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value !== 0;
    if (typeof value === "string") {
      const lower = value.trim().toLowerCase();
      if (lower === "true" || lower === "1" || lower === "yes") return true;
      if (lower === "false" || lower === "0" || lower === "no") return false;
    }
  }
  return null;
}
